
const use = (instance) => {
// 添加请求拦截器
  instance.interceptors.request.use(async (config) => {
    if (config.method == 'post' && config.data) {
      config.data = fixTime(config.data, '/')
    }
    if (config.method == 'get' && config.params) {
      config.params = fixTime(config.params, '/')
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  })
  instance.interceptors.response.use(
    (res) => {
      res.data = fixTime(res.data, '*')

      return res
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

export default use
